import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { myClosetPage, redesignPages } from "src/services/navigation/paths.const";
import { NavigationService } from "src/services/navigation/navigation.service";

@Component({
  selector: "rc-footer-menu",
  templateUrl: "./footer-menu.component.html",
  styleUrls: ["./footer-menu.component.scss"],
  standalone: false,
})
export class FooterMenuComponent {
  constructor(
    public readonly navigationService: NavigationService,
    private readonly router: Router,
  ) {}

  public isOnHomePage(): boolean {
    return this.isOnPage(redesignPages.homePage);
  }

  public isOnMyCloset(): boolean {
    return this.isOnPage(myClosetPage);
  }

  public isOnDeliveries(): boolean {
    return this.isOnPage(redesignPages.deliveries);
  }

  public isOnRewards(): boolean {
    return this.isOnPage(redesignPages.rewards);
  }

  public isOnAccount(): boolean {
    return this.isOnPage(redesignPages.myAccount);
  }

  private isOnPage(targetPage: string): boolean {
    return this.router.url.startsWith(`/${targetPage}`);
  }
}
